import {Directive, HostListener, Input} from '@angular/core';
import {GtmEventEnum} from '../enums/GoogleEnums';
import {ToolsService} from '../services/tools.service';
import {GtmService} from '../services/gtm.service';

@Directive({
  selector: '[appGtmEvent]',
})
export class GtmEventDirective {
  @Input() eventCategory: string;
  @Input() eventAction: string;
  @Input() eventLabel: string;
  @Input() eventValue: number;

  constructor(
    private tools: ToolsService,
    private gtmService: GtmService,
  ) {}

  @HostListener('click', ['$event']) onClick($event) {
    this.clickRegister();
  }

  private clickRegister(): void {
    const gtmTag = {
      event: GtmEventEnum.DEFAULT,
      Category: this.eventCategory,
      Action: this.eventAction,
      Label: !this.tools.isNil(this.eventLabel) ? this.eventLabel : '',
      Value: !this.tools.isNil(this.eventValue) ? this.eventValue : 1,
    };
    this.gtmService.pushTag(gtmTag);
  }
}
